import React from "react";
import { useController } from "react-hook-form";
import InputMask from "react-input-mask";

const PhoneInput = ({ name, control, rules = {}, disabled = false, defaultValue = '', ...props }) => {
    const { field, fieldState: { error } } = useController({
        name,
        control,
        defaultValue,
        rules,
        disabled
    });

    return <>
        <InputMask
            mask="+38(099)-999-99-99"
            type="tel"
            className='admin_modal_label'
            {...field}
            {...props}
        />
        {error?.message && <p className="form_error_txt">{error?.message}</p>}
    </>
};

export default PhoneInput;